import {
  faTimesCircle,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { ErrorMessage, Form, Formik } from "formik";
import { states } from "../../constants/states";
import * as Yup from "yup";
import FormikControl from "../../components/WraapperComponent/FormikControl";
import TextError from "../../components/WraapperComponent/TextError";
import { getSubscriptionListById } from "../../actions/subscriptionAction";
import { useDispatch, useSelector } from "react-redux";
const SubscriptionInfoPopup = ({ roleId, closePopup, setSubscriptionData }) => {
  const [activeSection, setActiveSection] = useState(0);
  const [activeSubscription, setActiveSubscription] = useState(null);
  const subscriptionList = useSelector(
    (state) => state.subscription.subscriptionList
  );
  const billingRef = useRef();
  const paymentRef = useRef();
  const dispatch = useDispatch();
  const onSubmit = (values) => {
    setActiveSection(2);
  };
  const initialValues = {
    firstname: "",
    lastname: "",
    email: "",
    address_1: "",
    address_2: "",
    city: "",
    state: "",
    phone: "",
    zip: "",
    addressNickname: "",
  };

  const validationSchema = Yup.object({
    firstname: Yup.string().nullable().required("This field is required"),
    lastname: Yup.string().nullable().required("This field is required"),
    email: Yup.string().nullable().email().required("This field is required"),
    phone: Yup.string()
      .nullable()
      .min(10, "Phone number must be 10 digits long")
      .max(10, "Phone number must be 10 digits long")
      .matches(
        /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
        "Phone number is not valid"
      )
      .required("This field is required"),
    address_1: Yup.string().nullable().required("This field is required"),
    city: Yup.string().nullable().required("This field is required"),
    state: Yup.string().nullable().required("This field is required"),
    zip: Yup.string()
      .nullable()
      .max(5)
      .min(5)
      .matches(/^\d{5}$/, "Zip code is not valid")
      .required("This field is required"),
    addressNickname: Yup.string().nullable(),
  });
  const initialCardValues = {
    nameOncard: "",
    cardNumber: "",
    expirationMonth: "",
    expirationYear: "",
    creditCardNickname: "",
  };

  const cardValidationSchema = Yup.object({
    nameOncard: Yup.string().nullable().required("This field is required"),
    cardNumber: Yup.string()
      .nullable()
      .min(12, "Credit card number be between 12 and 19 digits long")
      .max(19, "Credit card number be between 12 and 19 digits long")
      .matches(/^[0-9]*$/, "Credit card number is invalid")
      .required("This field is required"),
    expirationMonth: Yup.string()
      .nullable()
      .max(2, "Expiration month be 2 digits long")
      .matches(/^([1-9]|[0][1-9]|[1][0-2])$/, "Expiration month is invalid")
      .required("This field is required"),
    expirationYear: Yup.string()
      .nullable()
      .min(2, "Expiration year be 2 digits long")
      .max(2, "Expiration year be 2 digits long")
      .matches(/^[0-9]*$/, "Expiration year is invalid")
      .required("This field is required"),
    creditCardNickname: Yup.string().nullable(),
  });

  const cardOnSubmit = (values) => {
    setActiveSection(1);
  };

  useEffect(() => {
    dispatch(getSubscriptionListById(roleId));
  }, []);

  const handleSubmission = () => {
    billingRef.current.submitForm();
    paymentRef.current.submitForm();
    setTimeout(() => {
      if (Object.keys(paymentRef.current.errors).length) {
        setActiveSection(0);
      } else if (Object.keys(billingRef.current.errors).length) {
        setActiveSection(1);
      } else if (activeSubscription) {
        setSubscriptionData({
          ...billingRef.current.values,
          ...paymentRef.current.values,
          subscription_id: activeSubscription,
        });
        closePopup();
      }
    }, 10);
  };

  return (
    <Modal size="xl" show={true} id="subscription-popup">
      <Modal.Header>
        <div className="modal-title">
          <h5 className="profile-title">Subscription Information</h5>
          <FontAwesomeIcon icon={faTimesCircle} onClick={closePopup} />
        </div>
      </Modal.Header>
      <Modal.Body className="content-wrapper">
        <div className="d-flex justify-content-center">
          <div className="tab-wrapper">
            <div
              className={`tab ${activeSection === 0 ? "selected" : ""}`}
              onClick={() => setActiveSection(0)}
            >
              <h5>Payment </h5>
            </div>
            <div
              className={`tab ${activeSection === 1 ? "selected" : ""}`}
              onClick={() => setActiveSection(1)}
            >
              <h5>Billing </h5>
            </div>

            <div
              className={`tab ${activeSection === 2 ? "selected" : ""}`}
              onClick={() => setActiveSection(2)}
            >
              <h5>Subscription</h5>
            </div>
          </div>
        </div>

        <div className="detail-wrapper">
          <div className={`tab ${activeSection === 1 ? "tab-active" : ""}`}>
            <Formik
              innerRef={billingRef}
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
            >
              {({ errors, touched, setFieldValue, handleBlur }) => {
                return (
                  <Form>
                    <div className="row">
                      <div className="col-sm-6">
                        <FormikControl
                          control="forminput"
                          type="text"
                          label="* First Name"
                          name="firstname"
                          handleBlur={handleBlur}
                          hasError={errors.firstname && touched.firstname}
                        />
                      </div>
                      <div className="col-sm-6">
                        <FormikControl
                          control="forminput"
                          type="text"
                          label="* Last Name"
                          handleBlur={handleBlur}
                          name="lastname"
                          hasError={errors.lastname && touched.lastname}
                        />
                      </div>
                      <div className="col-sm-12">
                        <FormikControl
                          control="forminput"
                          type="text"
                          label="* Email"
                          name="email"
                          handleBlur={handleBlur}
                          hasError={errors.email && touched.email}
                        />
                      </div>
                      <div className="col-sm-8">
                        <FormikControl
                          control="forminput"
                          type="text"
                          label="* Street Address"
                          name="address_1"
                          handleBlur={handleBlur}
                          hasError={errors.address_1 && touched.address_1}
                        />
                      </div>
                      <div className="col-sm-4">
                        <FormikControl
                          control="forminput"
                          type="text"
                          label="Apt"
                          handleBlur={handleBlur}
                          name="address_2"
                          hasError={errors.address_2 && touched.address_2}
                        />
                      </div>
                      <div className="col-sm-8">
                        <FormikControl
                          control="forminput"
                          type="text"
                          label="* City"
                          handleBlur={handleBlur}
                          name="city"
                          hasError={errors.city && touched.city}
                        />
                      </div>
                      <div className="col-sm-4">
                        <FormikControl
                          control="dropdown"
                          label="State"
                          name="state"
                          handleBlur={handleBlur}
                          hasError={errors.state && touched.state}
                          options={states}
                        />
                      </div>
                      <div className="col-sm-6">
                        <FormikControl
                          control="forminput"
                          type="text"
                          label="* Phone"
                          name="phone"
                          handleBlur={handleBlur}
                          maxLength={10}
                          onPaste={(e) => {
                            const str = e.clipboardData.getData("Text");
                            const newStr = str.replace(/[^0-9]/g, "");
                            if (str !== newStr) {
                              e.preventDefault();
                              setFieldValue("phone", newStr);
                            }
                          }}
                          hasError={errors.phone && touched.phone}
                        />
                      </div>
                      <div className="col-sm-6">
                        <FormikControl
                          control="forminput"
                          type="text"
                          handleBlur={handleBlur}
                          label="* Zip code"
                          name="zip"
                          maxLength={5}
                          hasError={errors.zip && touched.zip}
                        />
                      </div>
                    </div>
                    <div className="submit-section mt-2 d-flex justify-content-end">
                      <button className="btn-orange" type="submit">
                        Next
                      </button>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </div>

          <div className={` tab ${activeSection === 0 ? "tab-active" : ""}`}>
            <Formik
              innerRef={paymentRef}
              initialValues={initialCardValues}
              validationSchema={cardValidationSchema}
              onSubmit={cardOnSubmit}
            >
              {({
                errors,
                touched,
                handleChange,
                handleBlur,
                setFieldValue,
                values,
              }) => {
                return (
                  <Form>
                    <div className="row">
                      <div className="col-sm-12">
                        <FormikControl
                          control="forminput"
                          type="text"
                          label="* Name on card"
                          name="nameOncard"
                          handleBlur={handleBlur}
                          hasError={errors.nameOncard && touched.nameOncard}
                        />
                      </div>

                      <div className="col-sm-12">
                        <FormikControl
                          control="forminput"
                          type="text"
                          label="* Credit card number"
                          name="cardNumber"
                          maxLength={19}
                          onKeyPress={(event) => {
                            if (!/[0-9]/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                          onChange={(e) => {
                            if (e.target.value.length < 20) {
                              setFieldValue("cardNumber", e.target.value);
                            }
                          }}
                          handleBlur={handleBlur}
                          hasError={errors.cardNumber && touched.cardNumber}
                        />
                      </div>
                      <div className="col-sm-6">
                        <FormikControl
                          control="forminput"
                          type="number"
                          label="* Expiration Month"
                          name="expirationMonth"
                          maxLength={2}
                          onChange={(e) => {
                            if (e.target.value.length < 3) {
                              setFieldValue("expirationMonth", e.target.value);
                            }
                          }}
                          handleBlur={handleBlur}
                          hasError={
                            errors.expirationMonth && touched.expirationMonth
                          }
                        />
                      </div>

                      <div className="col-sm-6">
                        <div
                          className={
                            errors.expirationYear && touched.expirationYear
                              ? "form-group star has-error"
                              : "star form-group"
                          }
                        >
                          <span className="input-focus"></span>
                          <label htmlFor="expirationYear">
                            * expiration Year
                          </label>
                          <div className="input year-field">
                            <label className="year-text">20-</label>
                            <input
                              type="number"
                              value={values.expirationYear}
                              onBlur={handleBlur}
                              onChange={(e) => {
                                if (e.target.value.length < 3) {
                                  setFieldValue(
                                    "expirationYear",
                                    e.target.value
                                  );
                                }
                              }}
                              maxLength={2}
                              className="form-control"
                              name="expirationYear"
                            />
                          </div>
                        </div>
                        <ErrorMessage
                          component={TextError}
                          name="expirationYear"
                        />
                      </div>
                    </div>
                    <div className="submit-section mt-2 d-flex justify-content-end">
                      <button className="btn-orange" type="submit">
                        Next
                      </button>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </div>

          <div className={`tab ${activeSection === 2 ? "tab-active" : ""}`}>
            <div className="subscription-items">
              {subscriptionList.map((x) => {
                return (
                  <div
                    key={x.subscriptionId}
                    className={`text-center pricing-card--basic pricing-card ${
                      x.subscriptionId === activeSubscription ? "active" : ""
                    } `}
                    onClick={() => {
                      setActiveSubscription(x.subscriptionId);
                    }}
                  >
                    <span className="active-icon">
                      {x.subscriptionId === activeSubscription ? (
                        <FontAwesomeIcon icon={faCheckCircle} color="green" />
                      ) : null}
                    </span>
                    <h3 className="pricing-card__plan-name text-major heading--4">
                      {x.name}
                    </h3>
                    <div className="text-center pricing-card-content">
                      <p className="pricing-card__plan-description">
                        Duration: {x.duration} Month(s)
                      </p>
                      <div className="pricing-card__monthly-content">
                        <span className="pricing-card__plan-price heading--1">
                          <span className="price">
                            $<span className="price__number">{x.price}</span>
                          </span>
                        </span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            {!activeSubscription && (
              <div className="error">Please choose subscription type</div>
            )}
            <div className="submit-section mt-2 d-flex justify-content-end">
              <button className="btn-orange" onClick={handleSubmission}>
                Save
              </button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default SubscriptionInfoPopup;
